import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import Reflux from 'reflux';
import actions from '../actions';
import facetStore from '../stores/item-preselection-facet-store';
import accessoryFacetStore from '../stores/accessory-facet-store';
import Facet from './facet';
import Slider from './slider';
import Panel from './panel';

export default createReactClass({

	propTypes: {
		id: PropTypes.string,
		title: PropTypes.string,
		subtitle: PropTypes.string,
		facets: PropTypes.array,
		inlineFacets: PropTypes.bool,
		slider: PropTypes.bool,
		onSelectProperty: PropTypes.func,
		onPropertyChange: PropTypes.func,
		itemCount: PropTypes.number,
		active: PropTypes.bool,
		isAccessory: PropTypes.bool,
		isFlapable: PropTypes.bool,
		showPreselectionItemCount: PropTypes.bool,
		sliderGoTo: PropTypes.number,
		topBorder: PropTypes.bool,
	},

	mixins: [
		Reflux.listenTo(facetStore, 'onFacetChange'),
		Reflux.listenTo(accessoryFacetStore, 'onFacetChange'),
	],


	getDefaultProps() {
		return {
			facets: [],
			hideTitle: false,
			inlineFacets: false,
			slider: true,
			onSelectProperty: actions.selectProperty.bind(actions),
			isFlapable: true,
			inline: false,
			sliderGoTo: null,
			topBorder: true
		};
	},

	getInitialState() {
		return {
			sliderGoTo: 0,
			loadingProperty: null
		};
	},

	getChildren() {
		const property = this.state.loadingProperty;
		return this.props.facets.map((facet) => {
			const hasProp = property && facet.properties.some(prop => property.id === prop.id);
			const loadingProperty = hasProp ? property : null;
			return (
				<Facet
					facet={facet}
					key={facet.id}
					onSelectProperty={this.onSelectProperty}
					inline={this.props.inlineFacets}
					isAccessory={this.props.isAccessory}
					loadingProperty={loadingProperty}
					showPreselectionItemCount={this.props.showPreselectionItemCount}
				/>
			);
		});
	},

	onSelectProperty(facet, property) {
		this.setState({sliderGoTo: this.props.facets.indexOf(facet)});
		this.setState({loadingProperty: property});
		this.props.onSelectProperty(facet, property);
		actions.wizLoading();
	},

	onFacetChange() {
		this.setState({loadingProperty: null});
		actions.wizLoadingDone();
	},

	onPanelToggle(selected) {
		this.setState({visible: selected});
	},

	render() {
		let content = '';
		if (this.props.slider) {
			const sliderGoTo = this.props.sliderGoTo !== null ? this.props.sliderGoTo : this.state.sliderGoTo;
			content = (
				<Slider
					goto={sliderGoTo}
					visible={this.state.visible}
				>
					{this.getChildren()}
				</Slider>
			);
		} else {
			content = this.getChildren();
		}

		if (this.props.facets.length <= 0) {
			return <span/>;
		}

		return (
			<Panel
				title={this.props.title}
				subtitle={this.props.subtitle}
				id={this.props.id}
				active={this.props.active}
				isFlapable={this.props.isFlapable}
				slider={this.props.slider}
				inline={this.props.inlineFacets}
				onToggle={this.onPanelToggle}
				topBorder={this.props.topBorder}
			>
				{content}
			</Panel>
		);
	}
});
